import React, { useState, useEffect, useRef } from 'react';
import DataTable, { defaultThemes } from 'react-data-table-component';
import { FaFileExcel } from "react-icons/fa";
import AgregarSolicitud from './AgregarSolicitud';
import EditarSolicitud from './EditarSolicitud';
import GestionCPO from './GestionCPO';
import ReplicarSolicitud from './ReplicarSolicitud';
import GenerarCorreo from './GenerarCorreo';
import CargarPreciosFletes from './CargarPreciosFletes';
import CargarTasas from './CargarTasas';
import * as XLSX from "xlsx";
import { Modal, Button, Spinner, Badge, Tooltip, Container, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { urlApiProd, print, formatDDMMYYYY, Checkbox } from '../utiles';
import Accordion from 'react-bootstrap/Accordion';
import { IoMailOpenOutline } from "react-icons/io5";

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const SolicitudesBooking = () => {
    const [loading, setLoading] = useState(true);
    const [dataSolicitudes, setDataSolicitudes] = useState([]);
    const [dataPuertos, setDataPuertos] = useState([]);
    const [dataFFW, setDataFFW] = useState([]);
    const [dataCarrier, setDataCarrier] = useState([]);
    const [dataSolicitudesInternas, setDataSolicitudesInternas] = useState([]);
    const [dataPreciosFletes, setDataPreciosFletes] = useState([]);
    const [showAgregar, setShowAgregar] = React.useState(false);
    const [showCargarPreciosFletes, setCargarPreciosFletes] = useState(false);
    const [showCargarTasas, setCargarTasas] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [showReplicar, setShowReplicar] = useState(false);
    const [showGenerarCorreo, setShowGenerarCorreo] = useState(false);
    const [solicitudReplicar, setSolicitudReplicar] = useState(null);
    const [showModalSolicitudesInternas, setShowModalSolicitudesInternas] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [solInterna, setFilterSolInterna] = useState('');
    const [filterFFW, setFilterFFW] = useState(''); // Filtro por FFW
    const [filterCarrier, setFilterCarrier] = useState(''); // Filtro por Carrier
    const [filterEstado, setFilterEstado] = useState(''); // Filtro por Estado
    const [filterMonth, setFilterMonth] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [apoyo, setApoyo] = useState(undefined);
    const [principal, setPrincipal] = useState(undefined);
    const firstRender = useRef(true);
    const [showCPO, setShowCPO] = useState(false);
    const [selectedCPO, setSelectedCPO] = useState(null);
    const [rowParaCorreo, setRowParaCorreo] = useState([]);
    const token = localStorage.getItem('token');

    const updateCheckStatus = async (row, alerta) => {
        print(`updateCheckStatus ${alerta} id_solicitud ${row.id_solicitud}`);

        if (alerta === 'alerta_coleta') {
            if (row.alerta_coleta.toString() === "0")
                row.alerta_coleta = 1;
            else
                row.alerta_coleta = 0;
        } else if (alerta === 'alerta_dlc') {
            if (row.alerta_dlc.toString() === "0")
                row.alerta_dlc = 1;
            else
                row.alerta_dlc = 0;
        }

        try {
            const response = await fetch(`${urlApiProd}/editsolicitudbooking/${row.id_solicitud}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(row)
            });


            if (response.ok) {
                const indx = dataSolicitudes.findIndex(b => b.id_solicitud === row.id_solicitud);

                if (indx !== -1) {

                    setDataSolicitudes(dataSolicitudes.map((solicitud, currentIndex) =>
                        currentIndex === indx
                            ? { ...solicitud, alerta_coleta: row.alerta_coleta, alerta_dlc: row.alerta_dlc }
                            : solicitud
                    ));

                }
                //fetchData();
            } else {
                alert("No fue posible actualizar");
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const fetchData = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/solicitudesbooking`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Error fetching Solicitudes');
            const data = await response.json();
            setDataSolicitudes(data);
            //setTotalItems(total);
            setPrincipal(true);
        } catch (error) {
            console.error('Error fetching data:', error);
            setPrincipal(false);
            toast.error(`Solicitudes no cargadas: ${error.message}`, { toastId: 'error-principal' });
        }
    };

    const fetchApoyo = async () => {
        const token = localStorage.getItem('token');
        try {

            fetchApoyoSolicitudesInternas();

            const responses = await Promise.all([
                fetch(`${urlApiProd}/puertos`, { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch(`${urlApiProd}/ffw`, { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch(`${urlApiProd}/carriers`, { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch(`${urlApiProd}/preciosfletes`, { headers: { 'Authorization': `Bearer ${token}` } }),
            ]);

            const [puertos, ffw, carriers, preciosFletes] = await Promise.all(responses.map(res => {
                if (!res.ok) throw new Error('Error fetching data');
                return res.json();
            }));

            puertos.sort((x, y) => {
                if (x.nombre < y.nombre) return -1;
                if (x.nombre > y.nombre) return 1;
                return 0;
            });

            setDataPuertos(puertos);
            setDataFFW(ffw);
            setDataCarrier(carriers);
            setDataPreciosFletes(preciosFletes.data || []);
            setApoyo(true);
        } catch (error) {
            console.error('Error en fetchApoyo:', error.message);
            setApoyo(false);
            toast.error(`Datos de apoyo no cargados: ${error.message}`, { toastId: 'error-apoyo' });
        }
    };

    const fetchApoyoSolicitudesInternas = async () => {
        const token = localStorage.getItem('token');
        try {
            const responses = await Promise.all([
                fetch(`${urlApiProd}/solicitudesinternas`, { headers: { 'Authorization': `Bearer ${token}` } }),
            ]);

            const [solicitudesInternas] = await Promise.all(responses.map(res => {
                if (!res.ok) throw new Error('Error fetching data');
                return res.json();
            }));

            const dataSolint = solicitudesInternas.filter(solicitud => solicitud.estado === 1 && solicitud.cantidad !== solicitud.cantidad_solicitada);

            setDataSolicitudesInternas(dataSolint);

        } catch (error) {
            console.error('fetchApoyoSolicitudesInternas:', error.message);
            toast.error(`fetchApoyoSolicitudesInternas: ${error.message}`, { toastId: 'error-apoyo' });
        }
    };

    useEffect(() => {
        if (firstRender.current) {
            setLoading(true);
            fetchData();
            fetchApoyo();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (principal !== undefined && apoyo !== undefined) {
            setLoading(!principal || !apoyo);
            if (principal && apoyo) {
                toast.success('Datos cargados correctamente.', { toastId: 'success' });
            } else {
                if (!principal) toast.error('Error en solicitudes booking.', { toastId: 'error-principal' });
                if (!apoyo) toast.error('Error en datos de apoyo.', { toastId: 'error-apoyo' });
            }
        }
    }, [principal, apoyo]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
    };


    const [showCorreo, setShowCorreo] = React.useState(false);

    const handleClose = () => { setShowCorreo(false); };

    const handleShowCorreo = (row) => {
        const ffwSeleccionado = dataFFW.find(ffw => ffw.id_ffw === parseInt(row.id_ffw));
        //print(`ffwSeleccionado ${ffwSeleccionado} origen ${puertos.find(p => p.id_puerto === formData.id_puerto_origen)?.nombre || ''} destino ${puertos.find(p => p.id_puerto === formData.id_puerto_destino)?.nombre || ''} carrier ${carriers.find(c => c.id_carrier === formData.id_carrier)?.nombre || ''}`);
        const saludo = getSaludo();
        const origen = dataPuertos.find(p => p.id_puerto.toString() === row.id_puerto_origen.toString())?.nombre || '';
        const destino = dataPuertos.find(p => p.id_puerto.toString() === row.id_puerto_destino.toString())?.nombre || '';
        const carrier = dataCarrier.find(c => c.id_carrier.toString() === row.id_carrier.toString())?.nombre || '';
        const cuerpoCorreo = `
    ETD: ${formatDDMMYYYY(row.etd)}
    REF: ${row.codigo}
    Quantidade: ${row.cantidad}x40HC Supertestado
    Cargo Weight: ${row.cargo_weight}
    POL: ${origen}
    POD: ${destino}
    Armador: ${carrier}
    Frete: USD $${row.flete}.
    Free time Brasil: ${row.ftorigen}
    Free time destino: ${row.ftdestino}
    
    ${row.requerimientos} `;

        setCorreoContenido(`
        ${saludo} ${ffwSeleccionado ? ffwSeleccionado.nombre_contacto[0] : ''},
        
        Tudo bem?
        
        ${cuerpoCorreo}
        Ficamos no aguardo dos BKs confirmados.
        
        Muito obrigado e boa semana.
        
        Saludos,
                `);

        setShowCorreo(true);

    };

    const handleCloseCancelar = () => {

        setShowCorreo(false);

    };

    const getSaludo = () => {
        const horaActual = new Date().getHours();
        //print(horaActual);
        return horaActual < 12 ? 'Bom dia' : 'Boa tarde';
    };

    const handleCopiarCorreo = async () => {
        navigator.clipboard.writeText(correoContenido).then(async () => {
            alert('Correo copiado al portapapeles.');

            const token = localStorage.getItem('token');

            if (rowParaCorreo.estado === 0) {
                rowParaCorreo.estado = 1;
                try {
                    const response = await fetch(
                        `${urlApiProd}/editsolicitudbooking/${rowParaCorreo.id_solicitud}`,
                        {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`
                            },
                            body: JSON.stringify(rowParaCorreo) // Cambiar estado a 2
                        }
                    );
                    if (!response.ok) {
                        alert('Correo enviado y estado de solicitud actualizado.');
                    } else {
                        fetchData();
                    }
                } catch (error) {
                    alert('Hubo un problema al actualizar las solicitudes. Por favor verifica manualmente.');
                }
            }
        }).catch(() => {
            alert('Error al copiar el correo.');
        });
    };

    const handleEnviarCorreo = async () => {

        const ffwSeleccionado = dataFFW.find(ffw => ffw.id_ffw === parseInt(rowParaCorreo.id_ffw));
        const email = ffwSeleccionado?.correo_contacto[0] || ''; // Email por defecto
        const subject = encodeURIComponent('Solicitações e bookings');
        const body = encodeURIComponent(correoContenido);

        // Abrir cliente de correo
        const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;

        const token = localStorage.getItem('token');

        if (rowParaCorreo.estado === 0) {
            rowParaCorreo.estado = 1;
            try {
                const response = await fetch(
                    `${urlApiProd}/editsolicitudbooking/${rowParaCorreo.id_solicitud}`,
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify(rowParaCorreo) // Cambiar estado a 2
                    }
                );
                if (!response.ok) {
                    alert('Correo enviado y estado de solicitud actualizado.');
                } else {
                    fetchData();
                }
            } catch (error) {
                alert('Hubo un problema al actualizar las solicitudes. Por favor verifica manualmente.');
            }
        }
    };

    const [correoContenido, setCorreoContenido] = useState('');


    useEffect(() => {
        console.log('Filtrando con:', { solInterna, filterText, filterMonth, filterYear, filterFFW, filterCarrier });
        const filtered = dataSolicitudes?.filter((row) => {
            const matchesText1 = solInterna ? row.id_puerto_origen === parseInt(solInterna) : true;

            const matchesText = filterText ? row.id_puerto_destino === parseInt(filterText) : true;

            const matchesFFW = filterFFW ? row.id_ffw === parseInt(filterFFW) : true;
            const matchesCarrier = filterCarrier ? row.id_carrier === parseInt(filterCarrier) : true;
            const matchesEstado = filterEstado ? row.estado === parseInt(filterEstado) : true;
            const matchesMonth = filterMonth
                ? new Date(row.fecha_creacion).getUTCMonth() + 1 === parseInt(filterMonth)
                : true;
            const matchesYear = filterYear
                ? new Date(row.fecha_creacion).getUTCFullYear() === parseInt(filterYear)
                : true;

            return matchesText1 && matchesText && matchesFFW && matchesCarrier && matchesEstado && matchesMonth && matchesYear;
        });
        setFilteredData(filtered);
    }, [dataSolicitudes, solInterna, filterText, filterFFW, filterCarrier, filterEstado, filterMonth, filterYear]);

    const columns = [
        { name: 'Booking', selector: row => row.nro_booking, sortable: true },
        { name: 'FFW', selector: row => row.id_ffw ? dataFFW.find(ffw => ffw.id_ffw === row.id_ffw)?.nombre : '', sortable: true },
        { name: 'Carrier', selector: row => dataCarrier.find(carrier => carrier.id_carrier === row.id_carrier)?.nombre || '', sortable: true },
        { name: 'FT Origen', selector: row => row.ftorigen },
        { name: 'FT Destino', selector: row => row.ftdestino, sortable: true },
        { name: 'Nave', selector: row => row.nave, sortable: true },
        { name: 'DLD', selector: row => row.dld, sortable: true },
        { name: 'DLC', selector: row => row.dlc, sortable: true },
        { name: 'ETD', selector: row => row.etd, sortable: true },
        { name: 'HC', selector: row => row.cantidad, sortable: true },
        {
            name: '',

            cell: row => (
                <div>
                    {
                        (row.estado === 0 || row.estado === 1) && row.ffw !== -1 &&
                        <Button variant="outline-primary" onClick={() => {
                            setRowParaCorreo(row);
                            handleShowCorreo(row);
                        }}>
                            <IoMailOpenOutline />
                        </Button>
                    }
                    {
                        (row.estado >= 2 &&
                            <div>
                                <Checkbox
                                    key={"Coletado"}
                                    isChecked={row.alerta_coleta === 1 ? true : false}
                                    checkHandler={() => updateCheckStatus(row, "alerta_coleta")}
                                    label={"Coletado"}
                                    index={row.id_solicitud + 1}
                                />
                                <Checkbox
                                    key={"En Puerto"}
                                    isChecked={row.alerta_dlc === 1 ? true : false}
                                    checkHandler={() => updateCheckStatus(row, "alerta_dlc")}
                                    label={"En Puerto"}
                                    index={row.id_solicitud + 2}
                                />
                            </div>
                        )}

                </div>
            ),
            ignoreRowClick: true,
        }
        /*   {
             name: 'Referencia',
             selector: row => row.codigo, sortable: true,
             width: '250px',
         },
         {
             name: 'Nave',
             selector: row => row.nave, sortable: true,
         },
         {
             name: 'N° Contenedores',
             selector: row => row.cantidad, sortable: true,
             width: '150px'
         },
         {
             name: 'ETD',
             selector: row => formatDate(row.etd), sortable: true,
         },
         {
             name: 'Origen',
             selector: row => dataPuertos.find(puerto => puerto.id_puerto === row.id_puerto_origen)?.nombre || '', sortable: true,
         },
         {
             name: 'Destino',
             selector: row => dataPuertos.find(puerto => puerto.id_puerto === row.id_puerto_destino)?.nombre || '', sortable: true,
         },
         {
             name: 'FFW',
             selector: row => row.id_ffw ? dataFFW.find(ffw => ffw.id_ffw === row.id_ffw)?.nombre : 'Sin FFW', sortable: true,
         },
         {
             name: 'Carrier',
             selector: row => dataCarrier.find(carrier => carrier.id_carrier === row.id_carrier)?.nombre || '', sortable: true,
         },
         {
             name: 'Fecha Creación',
             selector: row => row.fecha_creacion ? formatDate(row.fecha_creacion) : '', sortable: true,
         },
         {
             name: 'Estado',
             selector: row => row.estado === 0 ? 'Pendiente' : row.estado === 1 ? 'Solicitado' : row.estado === 2 ? 'Confirmado' : row.estado === 3 ? 'Embarcado' : row.estado === -1 ? 'Cancelado' : row.estado === 99 ? 'Transferencia' : 'Indefinido', sortable: true,
         },
         {
             name: 'Solicitud Interna',
             selector: row => row.solicitud_interna ? row.solicitud_interna.codigo : 'Sin Solicitud Interna', sortable: true,
         },
       {
             name: 'Acciones',
             cell: row => (
                 <div>
                     <button className='btn btn-outline-primary' onClick={() => handleEditar(row)}><LuPencilLine /></button>
                    <button
                         className='btn btn-outline-warning'
                         onClick={() => {
                             handleReplicar(row);
                         }}
                     >
                         <FaRegCopy />
                     </button> *
                     {row.estado === 0 &&
                         <button
                             className='btn btn-outline-danger'
                             onClick={() => {
                                 if (window.confirm('¿Estás seguro de eliminar esta solicitud?')) {
                                     handleEliminar(row.id_solicitud);
                                 }
                             }}
                         >
                             <IoTrashOutline />
                         </button>
                     }
                 </div>
             ),
             ignoreRowClick: true,
         }
         */
    ];

    const columnsInternas = [
        {
            name: 'Código',
            selector: row => row.codigo,
            width: '200px',
            sortable: true,
        },
        {
            name: 'Fecha Creacion',
            selector: row => formatDate(row.fecha_creacion),
            sortable: true,
        },
        {
            name: 'ETD',
            selector: row => formatDate(row.etd),
            sortable: true,
        },
        {
            name: 'Puerto Destino',
            selector: row => dataPuertos.find(p => p.id_puerto === row.id_puerto_destino)?.nombre || '',
            sortable: true,
        },
        {
            name: 'Cantidad',
            selector: row => `${row.cantidad_solicitada ?? 0}/${row.cantidad}`,
        },
        {
            name: 'Free Time Destino',
            selector: row => row.freetimedestino,
        },
        {
            name: 'Tipo BL',
            selector: row => row.tipo_bl,
        },
        {
            name: 'Estado',
            selector: row => row.estado === 0 ? 'Pendiente' : row.estado === 1 ? 'Solicitado' : row.estado === 2 ? 'Confirmado' : row.estado === 3 ? 'Embarcado' : row.estado === -1 ? 'Cancelado' : row.estado === 99 ? 'Transferencia' : 'Indefinido',
            sortable: true,
        },
        {
            name: 'Requerimientos',
            selector: row => row.requerimientos,
            sortable: true,
        },
    ];


    const exportToExcel = (solicitudes) => {

        // Preparar los datos para el Excel
        const preparedData = solicitudes.map((solicitud) => ({
            Invoice: solicitud.invoice, // Campo vacío
            Requerimiento: solicitud.codigo || "", // Campo amarillo
            Booking: solicitud.nro_booking,
            EstadoBKN: solicitud.estado === 0 ? 'Pendiente' : solicitud.estado === 1 ? 'Solicitado' : solicitud.estado === 2 ? 'Confirmado' : solicitud.estado === 3 ? 'Embarcado' : solicitud.estado === -1 ? 'Cancelado' : solicitud.estado === 99 ? 'Transferencia' : 'Indefinido',
            Comentarios: "",
            FW: solicitud.id_ffw ? dataFFW.find(f => f.id_ffw === solicitud.id_ffw)?.nombre || '' : '',
            Carrier: solicitud.id_carrier ? dataCarrier.find(c => c.id_carrier === solicitud.id_carrier)?.nombre || '' : '',
            FTO: solicitud.ftorigen || '',
            FTD: solicitud.ftdestino || '',
            Coleta: '',
            Estatus: '',
            DLDraft: solicitud.dld,
            Nave: solicitud.nave || '',
            DLCarga: solicitud.dlc,
            ETD: solicitud.etd,
            POL: solicitud.id_puerto_origen
                ? dataPuertos.find(p => p.id_puerto === solicitud.id_puerto_origen)?.nombre || ''
                : '',
            POD: solicitud.id_puerto_destino
                ? dataPuertos.find(p => p.id_puerto === solicitud.id_puerto_destino)?.nombre || ''
                : '',
            Cantidad: solicitud.cantidad || '',
            MAPA: solicitud.mapa,
            Observaciones: solicitud.requerimientos || '',
            Categoria: solicitud.categoria_booking,
            FreteUSD: solicitud.flete || '',
        }));

        // Crear la hoja de cálculo y el libro de trabajo
        const worksheet = XLSX.utils.json_to_sheet(preparedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Solicitudes");

        // Exportar el archivo Excel
        XLSX.writeFile(workbook, "SolicitudesBooking.xlsx");
    };



    const handleAgregar = () => setShowAgregar(true);

    const handleCloseAgregar = () => {
        setShowAgregar(false);
        fetchData();
        fetchApoyoSolicitudesInternas();
    };

    const handleShowModalSolicitudesInternas = () => setShowModalSolicitudesInternas(true);
    const handleCloseModalSolicitudesInternas = () => setShowModalSolicitudesInternas(false);

    const handleGenerarCorreo = () => setShowGenerarCorreo(true);

    const handleCloseGenerarCorreo = () => {
        setShowGenerarCorreo(false)
        fetchData();
    };

    const handleEditar = (solicitud) => {
        print(`solicitud ${JSON.stringify(solicitud)}`);
        setSelected(solicitud);
        setShowEditar(true);
    };

    const handleCPO = (solicitud) => {
        print(`solicitud ${JSON.stringify(solicitud)}`);
        setSelectedCPO(solicitud);
        setShowCPO(true);
    };

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false);
        fetchData();
    };

    const handleCloseCPO = () => {
        setSelectedCPO(null);
        setShowCPO(false);
        fetchData();
    };

    const handleReplicar = async (solicitud) => {
        setShowReplicar(true);
        setSolicitudReplicar(solicitud);
    };

    const handleCloseReplicar = () => {
        setShowReplicar(false);
        setSelected(null);
        fetchData();
    }

    const handleCargarPreciosFletes = () => setCargarPreciosFletes(true);

    const handleCargarTasas = () => setCargarTasas(true);

    const handleCloseCargarPreciosFletes = () => {
        setSelected(null);
        setCargarPreciosFletes(false);
        fetchData();
    };

    const handleCloseCargarTasas = () => {
        setSelected(null);
        setCargarTasas(false);
        fetchData();
    };

    const handleEliminar = async (id) => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/deletesolicitudbooking/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Error eliminando solicitud');
            alert('Solicitud eliminada exitosamente');
            fetchData();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo eliminar la solicitud');
        }
    };

    const handleCargaPreciosFletes = async () => {
        /*
                const fileInputRef = useRef<HTMLInputElement>(null);
                fileInputRef.current?.click();
                if(fileInputRef.target.files && fileInputRef.target.files[0]){
        
                    var data = await new Promise((resolve) =>{
                        let reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.readAsArrayBuffer(fileInputRef.target.files[0]);
                    });
                    
                    // Crear la hoja de cálculo y el libro de trabajo
                    var temp = new Uint8Array(data);
                    const workbook = XLSX.read(temp,{type: "array", sheetStubs:true});
                    var json = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]],{defval:''});
                
                }
                */

    };

    const clickSolicitud = row => {
        if (row.estado === -1 || row.estado === 0 || row.estado === 1) { handleEditar(row); }
        else {
            handleCPO(row);
        }
    }

    const [tooltipContent, setTooltipContent] = useState(
        undefined
    );
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

    const showTooltip = (row, event) => {
        setTooltipContent(
            row.requerimientos !== '' && row.requerimientos.length > 0
                ? row.requerimientos.toString()
                : ""
        );
        setTooltipPosition({ top: event.clientY, left: event.clientX });
    };

    const hideTooltip = () => {
        setTooltipContent(undefined);
    };

    const pendientesCount = dataSolicitudesInternas.length;

    const conditionalRowStyles = [
        {
            when: row => row.estado === 3,
            style: {
                backgroundColor: 'lightgreen',
                '&:hover': {
                    backgroundColor: 'lightgreen',
                    color: 'black',
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.estado === 2,
            style: {
                backgroundColor: '#BCE4FC',
                '&:hover': {
                    backgroundColor: '#BCE4FC',
                    color: 'black',
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.estado === 1,
            style: {
                backgroundColor: 'lemonchiffon',
                '&:hover': {
                    backgroundColor: 'lemonchiffon',
                    color: 'black',
                    cursor: 'pointer',
                },
            },
        }, {
            when: row => row.estado === 0,
            style: {
                backgroundColor: '#FFE1E6',
                '&:hover': {
                    backgroundColor: '#FFE1E6',
                    color: 'black',
                    cursor: 'pointer',
                },
            },
        }, {
            when: row => row.estado === -1,
            style: {
                backgroundColor: 'gainsboro',
                '&:hover': {
                    backgroundColor: 'gainsboro',
                    color: 'black',
                    cursor: 'pointer',
                },
            },
        }, {
            when: row => row.estado === 99,
            style: {
                backgroundColor: 'mintcream',
                '&:hover': {
                    backgroundColor: 'mintcream',
                    color: 'black',
                    cursor: 'pointer',
                },
            },
        }
    ];

    const customStyles = {
        header: {
            style: {
                minHeight: '56px',
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };

    return (
        <div className='container-fluid'>
            <div className='card'>
                <div className='card-header'>
                    <h3 className='card-title' style={{ textAlign: 'center' }}>Gestión de Booking</h3>
                </div>
                <div className='card-body'>
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" role="status" />
                            <span className="sr-only">Cargando...</span>
                        </div>
                    ) : (
                        <>
                            {/* Filtros */}
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Solicitudes Internas Pendientes    <Badge bg="danger" style={{ marginLeft: 10 }}>
                                        {pendientesCount}
                                    </Badge></Accordion.Header>
                                    <Accordion.Body>
                                        <DataTable
                                            columns={columnsInternas}
                                            customStyles={customStyles}
                                            data={dataSolicitudesInternas}
                                            noHeader
                                            highlightOnHover
                                            //paginationTotalRows={totalItems}
                                            onChangePage={handlePageChange}
                                            onRowClicked={(row, e) => showTooltip(row, e)}
                                        />
                                        {tooltipContent && (
                                            <Tooltip
                                                open={!!tooltipContent}
                                                title={tooltipContent}
                                                onClose={hideTooltip}
                                                style={{
                                                    position: "fixed",
                                                    top: tooltipPosition.top,
                                                    left: tooltipPosition.left
                                                }}
                                            >
                                                <div />
                                            </Tooltip>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>

                            <hr></hr>
                            <h4>Acciones</h4>
                            <hr></hr>
                            <div className="input-group mb-3 d-flex justify-content-between">
                                <div>

                                    <button className="btn btn-outline-primary" style={{ flex: 1, marginRight: 10, marginLeft: 10 }} onClick={handleAgregar}>Agregar Solicitud</button>
                                    {/*} <button className="btn btn-outline-success" style={{ flex: 1, marginRight: 10 }} onClick={handleGenerarCorreo}>Enviar Correos</button>*/}
                                    <button className="btn btn-outline-success" style={{ flex: 1, marginRight: 10 }} onClick={() => exportToExcel(filteredData)}>
                                        <FaFileExcel />Exportar
                                    </button>
                                    <button className="btn btn-outline-primary" style={{ flex: 1, marginRight: 10 }} onClick={handleCargarPreciosFletes}>Cargar Precios de Fletes</button>
                                    <button className="btn btn-outline-primary" style={{ flex: 1, marginRight: 10 }} onClick={handleCargarTasas}>Cargar Tasas</button>
                                </div>
                                <div>
                                </div>
                            </div>
                            <hr></hr>
                            <h4>Filtrar Bookings</h4>
                            <hr></hr>

                            <div className="row mb-4">

                                <div className="col-md-4">
                                    <select className="form-select" value={solInterna} onChange={(e) => setFilterSolInterna(e.target.value)}>
                                        <option value="">Puertos Origen</option>
                                        {dataPuertos.map((pod) => (
                                            <option key={pod.id_puerto} value={pod.id_puerto}>
                                                {pod.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select className="form-select" value={filterText} onChange={(e) => setFilterText(e.target.value)}>
                                        <option value="">Puertos Destino</option>
                                        {dataPuertos.map((pod) => (
                                            <option key={pod.id_puerto} value={pod.id_puerto}>
                                                {pod.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select
                                        className="form-select"
                                        value={filterFFW}
                                        onChange={(e) => setFilterFFW(e.target.value)}
                                    >
                                        <option value="">Todos los FFW</option>
                                        {dataFFW.map((ffw) => (
                                            <option key={ffw.id_ffw} value={ffw.id_ffw}>
                                                {ffw.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-4">


                                <div className="col-md-4">
                                    <select
                                        className="form-select"
                                        value={filterMonth}
                                        onChange={(e) => setFilterMonth(e.target.value)}
                                    >
                                        <option value="">Mes</option>
                                        {[...Array(12).keys()].map(month => (
                                            <option key={month + 1} value={month + 1}>
                                                {new Date(0, month).toLocaleString('default', { month: 'long' })}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select
                                        className="form-select"
                                        value={filterYear}
                                        onChange={(e) => setFilterYear(e.target.value)}
                                    >
                                        <option value="">Año</option>
                                        {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select
                                        className="form-select"
                                        value={filterCarrier}
                                        onChange={(e) => setFilterCarrier(e.target.value)}
                                    >
                                        <option value="">Todos los Carrier</option>
                                        {dataCarrier.map((carrier) => (
                                            <option key={carrier.id_carrier} value={carrier.id_carrier}>
                                                {carrier.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-12 mt-3 text-center">
                                    <div className="btn-group" role="group" aria-label="Estado de Solicitudes">
                                        {[
                                            { value: '', label: 'Todos', color: 'secondary' },
                                            //{ value: '0', label: 'Por Solicitar', color: 'warning' },
                                            { value: '0', label: 'Pendiente', color: 'danger' },
                                            { value: '1', label: 'Solicitado', color: 'warning' },
                                            { value: '2', label: 'Confirmado', color: 'primary' },
                                            { value: '3', label: 'Embarcado', color: 'success' },
                                            { value: '-1', label: 'Cancelado', color: 'secondary' },
                                            { value: '99', label: 'Transferencia', color: 'info' }
                                        ].map(({ value, label, color }) => {
                                            // Calcular número de solicitudes para cada estado considerando los otros filtros
                                            const sortedData = Array.isArray(dataSolicitudes) ? dataSolicitudes.slice().sort((a, b) => a.id - b.id) : [];
                                            const filteredCount = sortedData.filter((row) => {
                                                const matchesText = filterText ? row.id_puerto_destino === parseInt(filterText) : true;
                                                const solinterna = solInterna ? row.id_puerto_destino === parseInt(solInterna) : true;
                                                const matchesFFW = filterFFW ? row.id_ffw === parseInt(filterFFW) : true;
                                                const matchesCarrier = filterCarrier ? row.id_carrier === parseInt(filterCarrier) : true;
                                                const matchesEstado = value === '' ? true : row.estado === parseInt(value);

                                                return matchesText && solinterna && matchesFFW && matchesCarrier && matchesEstado;
                                            }).length;

                                            return (
                                                <button
                                                    key={value}
                                                    type="button"
                                                    className={`btn btn-outline-${color} ${filterEstado === value ? 'active' : ''}`}
                                                    onClick={() => setFilterEstado(value)}
                                                >
                                                    {label} ({filteredCount})
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>


                            <hr></hr>

                            <DataTable
                                conditionalRowStyles={conditionalRowStyles}
                                customStyles={customStyles}
                                columns={columns}
                                data={filteredData}
                                noHeader
                                pagination
                                paginationPerPage={15}
                                highlightOnHover
                                //paginationTotalRows={totalItems}
                                onChangePage={handlePageChange}
                                onRowClicked={clickSolicitud}
                                defaultSortFieldId={1}
                            />
                        </>
                    )}
                </div>
            </div>

            {showCargarTasas && <CargarTasas preciosFletes={dataPreciosFletes} puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} cerrar={handleCloseCargarTasas} />}
            {showCargarPreciosFletes && <CargarPreciosFletes preciosFletes={dataPreciosFletes} puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} cerrar={handleCloseCargarPreciosFletes} />}
            {showAgregar && <AgregarSolicitud solicitudes={dataSolicitudes} puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} solicitudesInternas={dataSolicitudesInternas} cerrar={handleCloseAgregar} />}
            {showReplicar && <ReplicarSolicitud puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} solicitudesInternas={dataSolicitudesInternas} solicitud={solicitudReplicar} cerrar={handleCloseReplicar} />}
            {selected && showEditar && <EditarSolicitud solicitud={selected} puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} solicitudesInternas={dataSolicitudesInternas} cerrar={handleCloseEditar} />}
            {selectedCPO && showCPO && <GestionCPO desde={'bookingexterno'} solicitud={selectedCPO} puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} solicitudesInternas={dataSolicitudesInternas} cerrar={handleCloseCPO} />}
            {showGenerarCorreo && <GenerarCorreo solicitudes={dataSolicitudes} puertos={dataPuertos} ffws={dataFFW} carriers={dataCarrier} cerrar={handleCloseGenerarCorreo} />}

            <Modal show={showModalSolicitudesInternas} onHide={handleCloseModalSolicitudesInternas}>
                <Modal.Header closeButton>
                    <Modal.Title>Solicitudes Internas Pendientes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pendientesCount > 0 ? (
                        <ul>
                            {dataSolicitudesInternas
                                .filter(solicitud => solicitud.estado !== 1)
                                .map(solicitud => {
                                    const puerto = dataPuertos.find(p => p.id_puerto === solicitud.id_puerto_destino)
                                    if (puerto) {
                                        return (
                                            <li key={solicitud.id_solicitudinterna}>
                                                {solicitud.codigo} - {puerto.nombre}
                                            </li>
                                        )
                                    } else return (<></>)
                                })}
                        </ul>
                    ) : (
                        <p>No hay solicitudes internas pendientes.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalSolicitudesInternas}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showCorreo} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Armar Correo de booking?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">Contenido del Correo</label>
                        <textarea
                            className="form-control"
                            value={correoContenido}
                            rows="10"
                            readOnly
                        ></textarea>
                    </div>
                    <div className="mb-3">
                        <button
                            type="button"
                            className="btn btn-secondary me-2"
                            onClick={handleCopiarCorreo}
                        >Copiar Correo
                        </button>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleEnviarCorreo}
                        >
                            Armar Correo
                        </button>

                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SolicitudesBooking;
